import {FC, Suspense} from 'react'
import {Route, Routes, Navigate} from 'react-router-dom'
import {MasterLayout} from '../../_metronic/layout/MasterLayout'
import TopBarProgress from 'react-topbar-progress-indicator'
import {getCSSVariableValue} from '../../_metronic/assets/ts/_utils'
import {WithChildren} from '../../_metronic/helpers'
import {AdminDashboardWrapper} from '../pages/dashboard/AdminDashboard'
import {UsersManagementPage} from '../pages/users/UsersPage'
import {EventsPageWrapper} from '../pages/events/EventsPage'
import {ProvidersPageWrapper} from '../pages/providers/ProvidersPage'
import {BookingsPageWrapper} from '../pages/bookings/BookingsPage'
import {OrdersPageWrapper} from '../pages/orders/OrdersPage'
import {InterestsPageWrapper} from '../pages/interests/InterestsPage'
import {ServiceCategoriesPageWrapper} from '../pages/service-categories/ServiceCategoriesPage'
import {CouponsPageWrapper} from '../pages/coupons/CouponsPage'
import {DisputesPageWrapper} from '../pages/disputes/DisputesPage'
import {RedeemCodesPageWrapper} from '../pages/redeem-codes/RedeemCodesPage'
import {PayoutsPageWrapper} from '../pages/payouts/PayoutsPage'
import {AccountSettingsWrapper} from '../pages/account/AccountSettingsPage'
import {HostApplicationsPageWrapper} from '../pages/host-applications/HostApplicationsPage'
import {ActivityFeedPageWrapper} from '../pages/activity/ActivityFeedPage'
import {BroadcastPageWrapper} from '../pages/notifications/BroadcastPage'
import {AnalyticsPageWrapper} from '../pages/analytics/AnalyticsPage'
import {ProviderPerformancePageWrapper} from '../pages/provider-performance/ProviderPerformancePage'
import {PaymentsDisputesPageWrapper} from '../pages/payments-disputes/PaymentsDisputesPage'
import {LegalDocumentsPageWrapper} from '../pages/legal-documents/LegalDocumentsPage'

const PrivateRoutes = () => {
  return (
    <Routes>
      <Route element={<MasterLayout />}>
        <Route path='auth/*' element={<Navigate to='/dashboard' />} />
        <Route path='dashboard' element={<AdminDashboardWrapper />} />
        <Route path='users' element={<UsersManagementPage />} />
        <Route path='events' element={<EventsPageWrapper />} />
        <Route path='providers' element={<ProvidersPageWrapper />} />
        <Route path='bookings' element={<BookingsPageWrapper />} />
        <Route path='orders' element={<OrdersPageWrapper />} />
        <Route path='event-types' element={<InterestsPageWrapper />} />
        {/* Legacy path kept so old bookmarks/links still resolve */}
        <Route path='interests' element={<InterestsPageWrapper />} />
        <Route path='coupons' element={<CouponsPageWrapper />} />
        <Route path='disputes' element={<DisputesPageWrapper />} />
        <Route path='payments-disputes' element={<PaymentsDisputesPageWrapper />} />
        <Route path='redeem-codes' element={<RedeemCodesPageWrapper />} />
        <Route path='payouts' element={<PayoutsPageWrapper />} />
        <Route path='service-categories' element={<ServiceCategoriesPageWrapper />} />
        <Route path='analytics' element={<AnalyticsPageWrapper />} />
        <Route path='provider-performance' element={<ProviderPerformancePageWrapper />} />
        <Route path='activity' element={<ActivityFeedPageWrapper />} />
        <Route path='broadcast' element={<BroadcastPageWrapper />} />
        <Route path='legal-documents' element={<LegalDocumentsPageWrapper />} />
        <Route path='account/settings' element={<AccountSettingsWrapper />} />
        <Route path='host-applications' element={<HostApplicationsPageWrapper />} />
        <Route path='*' element={<Navigate to='/dashboard' />} />
      </Route>
    </Routes>
  )
}

const SuspensedView: FC<WithChildren> = ({children}) => {
  const baseColor = getCSSVariableValue('--bs-primary')
  TopBarProgress.config({
    barColors: {'0': baseColor},
    barThickness: 1,
    shadowBlur: 5,
  })
  return <Suspense fallback={<TopBarProgress />}>{children}</Suspense>
}

export {PrivateRoutes, SuspensedView}
